(() => {
  let pending = false;
  const overlaps = (a, b) => a.width > 0 && a.height > 0 && b.width > 0 && b.height > 0 && a.left < b.right + 8 && a.right > b.left - 8 && a.top < b.bottom + 8 && a.bottom > b.top - 8;
  const update = () => {
    pending = false;
    const protectedRects = [...document.querySelectorAll('.product-info__price, product-form button[name="add"], .shopify-payment-button, .slideshow .btn')]
      .filter(el => getComputedStyle(el).visibility !== 'hidden')
      .map(el => el.getBoundingClientRect());
    const teaser = document.querySelector('.famiware-discount-teaser');
    if (teaser) {
      const rect = teaser.getBoundingClientRect();
      teaser.classList.toggle('famiware-avoid-content', !teaser.contains(document.activeElement) && protectedRects.some(target => overlaps(rect, target)));
    }
    const host = document.querySelector('shopify-chat');
    const button = host?.shadowRoot?.querySelector('shopify-agent-runtime')?.shadowRoot?.querySelector('[part="activator"]');
    if (button) {
      const rect = button.getBoundingClientRect();
      host.classList.toggle('famiware-avoid-content', button.getAttribute('aria-expanded') !== 'true' && document.activeElement !== host && protectedRects.some(target => overlaps(rect, target)));
    }
  };
  const schedule = () => {
    if (!pending) { pending = true; requestAnimationFrame(update); }
  };
  document.addEventListener('scroll', schedule, { passive: true, capture: true });
  document.addEventListener('focusout', schedule);
  window.addEventListener('resize', schedule, { passive: true });
  window.addEventListener('load', schedule, { once: true });
  document.addEventListener('change', schedule);
  [0, 1000, 4000, 10000].forEach(delay => setTimeout(schedule, delay));
})();
